import { useState, useEffect } from "react";
import { Button, Box, TextField } from "@mui/material";
import { UseProductType } from "./UseProductType";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";

function AddProductType(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const location = useLocation();
  const [productType, setProductType] = useState();
  const { validate, addProductType } = UseProductType();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const { isSmall } = useBreakpoints();

  const [state, setState] = useState({
    id: undefined,
    faName: undefined,
    enName: undefined,
  });

  const [errorState, setErrorState] = useState({
    faName: false,
    enName: false,
  });

  return (
    <Detail
      breadChilds={{
        title: "اطلاعات پایه",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/producttypes" },
          { name: "افزودن نوع محصول", url: "/producttypes/addproducttype" },
        ],
      }}
    >
      {!productType ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.faName ? state.faName : ""}
              error={errorState.faName}
              label="نام فارسی"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, faName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.enName ? state.enName : ""}
              error={errorState.enName}
              sx={{ input: { direction: "rtl" } }}
              label="نام لاتین"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, enName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  setMsGotoLast(true);
                  addProductType(state, () => {
                    navigate("/producttypes", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/producttypes", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}

export default AddProductType;
